export function isEmpty(value) {
  if (value == null) return true;
  if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
}

export function compact(array) {
  return array.filter(Boolean);
}

export function mergeObjects(...sources) {
  return Object.assign({}, ...sources);
}
